import { createContext } from "react";

const TodayContext = createContext();

export default TodayContext;